import React, { Component } from 'react';
import { Tabs } from 'antd';
import Filter from './Filter';
import List from './List';

const { TabPane } = Tabs;
const Pagination = {
    current: 1,
    pageSize: 11,
};

class TablePage extends Component {
    constructor(props) {
        super(props);
        this.panes = [{
            title: '正常开票',
            key: '0',
            content: this.getContent,
        }, {
            title: '异常开票',
            key: '1',
            content: this.getContent,
        }];
        this.state = {
            activeKey: '0',
            pagination: { ...Pagination },
            sortParams: {},
            load: null,
        };
    }
    
    search = () => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            load: {},
            pagination,
        });
    }

    handleChange = (params, isLoad) => {
        const settings = {
            ...params,
        };
        if (isLoad) {
            settings.load = {};
        }
        this.setState(settings);
    }

    getContent = (key) => {
        const { searchParams, clientHeight, notice } = this.props;
        const { activeKey, sortParams, pagination, load } = this.state;
        const height = clientHeight - 72 - 94 - 45 - 100;
        if (key === activeKey) {
            return (
                <List
                    load={load}
                    height={height}
                    notice={notice}
                    activeKey={activeKey}
                    sortParams={sortParams}
                    pagination={pagination}
                    searchParams={searchParams}
                    onChange={this.handleChange}
                />
            );
        }
    }

    handleTabsChange = (activeKey) => {
        this.setState({
            activeKey,
            sortParams: {},
            pagination: { ...Pagination },
        });
    }

    render() {
        const { searchParams, businessList, onChange } = this.props;
        const { activeKey, sortParams } = this.state;

        return (
            <div className="pane-item-content">
                <Filter
                    search={this.search}
                    sortParams={sortParams}
                    searchParams={searchParams}
                    businessList={businessList}
                    onChange={onChange}
                />
                <Tabs type="card" activeKey={activeKey} onChange={this.handleTabsChange}>
                    {this.panes.map(pane => <TabPane tab={pane.title} key={pane.key}>{pane.content(pane.key)}</TabPane>)}
                </Tabs>
            </div>
        );
    }
}

export default TablePage;


// WEBPACK FOOTER //
// ./src/components/RequestDataAnalysis/RequestToDo/InvoiceData/TablePage/index.js